import "./index.scss";

import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { useAppSelector, useAppDispatch } from "../../store/hook";
import { ResultFull, SendBet } from "../result/type";
import { ASSETS_IMAGE_CACHED } from "../hook/PreloadImage";

import useOrientation from "../hook/Orientation";
import {
  changeAmount,
  changeDifficulty,
  changeMode,
  startBet,
  stopBet,
} from "../betbar/reducer";
import { countOpen, openBomb, selectToOpen } from "./reducer";
import {
  loadLastPath,
  resetResult,
  resultFinished,
  sendBetAction,
} from "../result/reducer";
import sound from "../../sound";
import { changeRound } from "../history/reducer";
import { Chest } from "./chest";
import { HistoryData, HistoryFull } from "../history/type";
import { formatCurrency } from "../../tool/money";
import { useTranslation } from "react-i18next";
import { getPlayer } from "../user/auth/reducer";
import { Player } from "../user/auth/type";

interface GameIProps {
  dataProps?: null | HistoryFull;
  idx?: number;
}

declare global {
  interface Window {
    Phaser: any;
    dragon: any;
    add: any;
    game: any;
    gameSelected: any;
    gameReady: any;
    portals: any;
    dataPos: any;
    prizes: any;
    totalProfit: any;
    textProfit: any;
    timeoutProfit: any;
    frame: any;
    preload: any;
    SpinePlugin: any;
    PhaserLoaderPlugin: any;
    SpineWebGLPlugin: any;
    currPortalLevel: number;
    // openPortal: ((newPortal: "open-win-" | "open-lose-", i?: any) => void) | null
    sweepPortal: (sendBet: SendBet, idxPortal: number) => void;
    handleCashOut: () => void;
  }
}
let phaserElement: any;
let animating = false;

export const difficultyToAnime: any = {
  easy: "easy",
  medium: "normal",
  hard: "hard",
  expert: "expert",
  master: "master",
};
const difficultyData = ["easy", "medium", "hard", "expert", "master"];
const orientationData = ["landscape", "portrait"];

const Game: React.FC<GameIProps> = (
  { dataProps, idx } = { dataProps: undefined, idx: -1 }
) => {
  const dispatch = useAppDispatch();

  const orientation = useOrientation();
  const result = useAppSelector((state) => state.result);
  const playerbet = useAppSelector((state) => state.playerbet);
  const last_bet = useAppSelector((state) => state.playerbet.last_bet);
  const game = useAppSelector((state) => state.game);
  const current_round = useAppSelector((state) => state.history.current_round);
  const history: any = { current_round };
  const player = useAppSelector(getPlayer) as Player;

  const { player_balance, player_name, player_currency } = player;
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const handleFormatCurrency = (amount: number): string => {
    return formatCurrency(amount, player_currency, language);
  };
  // Move phaser canvas here
  useEffect(() => {
    if (document.getElementById("phaser")) {
      //    console.log("console remove", document.getElementById('phaser'))

      phaserElement = document.getElementById("phaser");
    }

    if (phaserElement) {
      console.log("console add", phaserElement);
      (
        document.querySelector(".game-container.main")!
          .firstChild as HTMLElement
      ).appendChild(phaserElement);
      // return ()=>{
      //     if(document.getElementById('phaser')){
      //    console.log("console remove", document.getElementById('phaser'))

      //      phaserElement = document.getElementById('phaser');
      //     }
      //     (ref.current.firstChild as HTMLElement).removeChild(phaserElement)
      // }
    }
  }, []);

  // setup dragon position
  useEffect(() => {
    if (window.dragon) {
      if (orientation == "portrait") {
        window.dragon.setY(460);
        window.dragon.setX(510);
      } else {
        window.dragon.setY(530);
        window.dragon.setX(450);
      }
    }
  }, [orientation, window.dragon]);

  // setup fram position
  useEffect(() => {
    if (window.frame) {
      if (orientation == "portrait") {
        window.frame.setY(730);
        window.frame.setX(530);
        window.frame.setScale(1.6);
      } else {
        window.frame.setY(587);
        window.frame.setX(483);
        window.frame.setScale(1);
      }
    }
  }, [orientation, window.frame]);

  window.sweepPortal = useCallback(
    (sendBet, idxChest) => {
      if (result.payload.last_bet) {
        if (
          result.payload.last_bet.button_bet.state == "sweep" &&
          result.payload.last_bet.button_bet.path == idxChest + ""
        ) {
        } else {
          if (result.status !== "loading") dispatch(sendBetAction(sendBet));
        }
      }
    },
    [
      result.status,
      result.payload.last_bet && result.payload.last_bet.button_bet.state,
      result.payload.last_bet && result.payload.last_bet.button_bet.path,
    ]
  );

  // Orientation cleaning
  useLayoutEffect(() => {
    const requestOrientationCleaning = requestAnimationFrame(() => {
      orientationData.map((mode) => {
        difficultyData.map((level) => {
          if (window.prizes) {
            window.prizes.map((prize: any) => {
              prize.destroy();
            });
            window.prizes = [];
          }
          window.portals[mode] &&
            window.portals[mode][level] &&
            window.portals[mode][level].map((portal: any) => {
              portal.setTexture(window.dataPos[mode][level].imgName);
              // portal.blendMode = window.Phaser.BlendModes.NORMAL;
              portal.removeAllListeners();
              if (portal.alpha != 0) {
                window.game.scene.getAt(0).tweens.add({
                  targets: portal,
                  scaleX: 0,
                  scaleY: 0,
                  alpha: 0,
                  delay: 0,
                  duration: 0,
                  onComplete: () => {},
                });
              }
            });
        });
      });
      // }, 0);
    });
    console.log("do requestOrientationCleaning");

    return () => {
      console.log("cancel requestOrientationCleaning");
      cancelAnimationFrame(requestOrientationCleaning);
    };
  }, [orientation]);

  // succeeded manual startup only
  useEffect(() => {
    if (playerbet.currMode == "manual") {
      if (result.status == "succeeded") {
        if (
          window.portals[orientation] &&
          window.portals[orientation][playerbet.manual.difficulty]
        ) {
          const handleManual = () => {
            // if(window.portals[orientation][playerbet.manual.difficulty].some((i: any)=>i._alpha !==0)) return;

            const handleClick = (
              e: any,
              portalLevel: number,
              idxChest: number
            ) => {
              const handleOnClick = () => {
                // console.log(e, animating, !window.currPortalLevel, portalLevel, window.currPortalLevel, !playerbet.manual.start);
                if (
                  !window.currPortalLevel ||
                  portalLevel != window.currPortalLevel ||
                  !playerbet.manual.start
                )
                  return;
                // if(window.prizes.length+1!==window.currPortalLevel) return;
                // const array: any = ['open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-lose-', 'open-lose-', 'open-lose-', 'open-lose-'];

                // const newPortalTexture = array[Math.floor(Math.random() * array.length)].concat(playerbet.manual.difficulty);

                window.portals[orientation][playerbet.manual.difficulty][
                  idxChest
                ].openPortal = (newPortalTexture: string, idxChest: number) => {
                  if (
                    !window.currPortalLevel ||
                    portalLevel != window.currPortalLevel ||
                    !playerbet.manual.start
                  )
                    return;

                  e.setTexture(
                    newPortalTexture.concat(playerbet.manual.difficulty)
                  );
                  if (newPortalTexture.includes("lose")) {
                    animating = true;
                    window.dragon.setAnimation(0, "lose", false);
                    window.currPortalLevel = 1;
                    const currPortal = [
                      ...window.portals[orientation][
                        playerbet.manual.difficulty
                      ],
                    ].reverse();
                    chunkArray(
                      currPortal,
                      window.dataPos[orientation][playerbet.manual.difficulty]
                        .col
                    ).map((chunk, idx) => {
                      chunk.map((i: any) => {
                        i.removeAllListeners();
                      });
                    });
                    setTimeout(() => {
                      window.dragon.setAnimation(0, "idle", true);
                      const currPortal = [
                        ...window.portals[orientation][
                          playerbet.manual.difficulty
                        ],
                      ].reverse();
                      chunkArray(
                        currPortal,
                        window.dataPos[orientation][playerbet.manual.difficulty]
                          .col
                      ).map((chunk, idx) => {
                        chunk.map((i: any) => i.setAlpha(0.3));
                        if (idx + 1 <= window.currPortalLevel) {
                          chunk.map((i: any) => {
                            i.setAlpha(1);
                            console.log("setAlpha 1");
                          });
                        }
                      });
                      animating = false;
                    }, window.dragon.state.tracks[window.dragon.state.tracks.length - 1].animation.duration * 1000);
                    dispatch(stopBet());

                    dispatch(openBomb());
                    // dispatch(resultFinished());
                    // dispatch(resetResult());

                    sound.playBomb();
                    window.prizes.push(
                      window.add.spine(
                        e.x,
                        e.y - 40,
                        "skull",
                        "".concat(
                          difficultyToAnime[playerbet.manual.difficulty]
                        ),
                        false
                      )
                    );
                    window.prizes[window.prizes.length - 1].setScale(
                      window.dataPos[orientation][playerbet.manual.difficulty]
                        .scale || 1
                    );
                  }
                  if (newPortalTexture.includes("win")) {
                    animating = true;
                    window.dragon.setAnimation(0, "win", false);
                    window.currPortalLevel = window.currPortalLevel + 1;
                    const currPortal = [
                      ...window.portals[orientation][
                        playerbet.manual.difficulty
                      ],
                    ].reverse();
                    chunkArray(
                      currPortal,
                      window.dataPos[orientation][playerbet.manual.difficulty]
                        .col
                    ).map((chunk, idx) => {
                      chunk.map((i: any) => i.setAlpha(0.3));

                      if (idx + 1 <= window.currPortalLevel) {
                        chunk.map((i: any) => {
                          i.setAlpha(1);
                          console.log("setAlpha 1");
                        });
                      }
                    });
                    setTimeout(() => {
                      window.dragon.setAnimation(0, "idle", true);
                      const currPortal = [
                        ...window.portals[orientation][
                          playerbet.manual.difficulty
                        ],
                      ].reverse();
                      chunkArray(
                        currPortal,
                        window.dataPos[orientation][playerbet.manual.difficulty]
                          .col
                      ).map((chunk, idx) => {
                        if (idx + 1 < window.currPortalLevel) {
                          chunk.map((i: any) => {
                            i.removeAllListeners();
                            // i.blendMode = window.Phaser.BlendModes.NORMAL;
                          });
                        }
                      });
                      if (window.currPortalLevel - 1 == 9)
                        window.handleCashOut();
                      animating = false;
                    }, window.dragon.state.tracks[window.dragon.state.tracks.length - 1].animation.duration * 1000);
                    dispatch(countOpen(game.openCount + 1));
                    sound.playGem();
                    window.prizes.push(
                      window.add.spine(
                        e.x,
                        e.y,
                        "egg",
                        "egg ".concat(
                          difficultyToAnime[playerbet.manual.difficulty]
                        ),
                        false
                      )
                    );
                    window.prizes[window.prizes.length - 1].setScale(
                      window.dataPos[orientation][playerbet.manual.difficulty]
                        .scale || 1
                    );
                  }
                };

                const sendBet: SendBet = {
                  game: "DP000001",
                  total_amount: playerbet.manual.amount,
                  button_bet: {
                    amount: playerbet.manual.amount,
                    difficulty: playerbet.manual.difficulty,
                    path: idxChest + "",
                    round_id: history.current_round,
                    state: "sweep",
                  },
                  round_id: history.current_round,
                };
                // console.log("sweep", idxChest)
                window.sweepPortal(sendBet, idxChest);
              };

              return handleOnClick;
            };

            const row = 9;
            let portalLevel = row;
            window.portals[orientation][playerbet.manual.difficulty].map(
              (portal: any, idx: number) => {
                window.portals[orientation][playerbet.manual.difficulty][
                  idx
                ].handleClick = handleClick(portal, portalLevel, idx);
                portal.removeAllListeners();
                window.game.scene.getAt(0).tweens.add({
                  targets: portal,
                  scaleX:
                    window.dataPos[orientation][playerbet.manual.difficulty]
                      .scale || 1,
                  scaleY:
                    window.dataPos[orientation][playerbet.manual.difficulty]
                      .scale || 1,
                  alpha: portal._alpha !== 0 ? portal._alpha : 1,
                  delay: 0,
                  duration: 300,
                  onComplete: () => {
                    // console.log('pointerdown', idx);
                    portal.removeAllListeners();
                    portal.on(
                      "pointerdown",
                      window.portals[orientation][playerbet.manual.difficulty][
                        idx
                      ].handleClick
                    );
                    if (
                      playerbet.manual.start &&
                      idx ==
                        window.portals[orientation][playerbet.manual.difficulty]
                          .length -
                          1
                    ) {
                      const currPortal = [
                        ...window.portals[orientation][
                          playerbet.manual.difficulty
                        ],
                      ].reverse();
                      chunkArray(
                        currPortal,
                        window.dataPos[orientation][playerbet.manual.difficulty]
                          .col
                      ).map((chunk, idx) => {
                        chunk.map((i: any) => i.setAlpha(0.3));
                        if (idx + 1 <= window.currPortalLevel) {
                          chunk.map((i: any) => {
                            i.setAlpha(1);
                            console.log("setAlpha 1");
                          });
                        }
                        if (idx + 1 == 1) {
                          chunk.map((i: any) => {
                            // i.on('pointerover', function () {
                            //     i.blendMode = window.Phaser.BlendModes.ADD;
                            // });
                            // i.on('pointerout', function () {
                            //     i.blendMode = window.Phaser.BlendModes.NORMAL;
                            // });
                          });
                        }
                      });

                      if (result.status == "succeeded")
                        if (result.payload.path && result.payload.path.length) {
                          // auto cashout
                          // setShadowOpen(false);
                          // setContentState("diamond");
                          const arrIdxChest =
                            window.portals[orientation][
                              playerbet.manual.difficulty
                            ];
                          arrIdxChest.map((i: any) => {
                            // i.removeAllListeners();
                            // i.blendMode = window.Phaser.BlendModes.NORMAL;
                          });
                          const fromBottom = [
                            ...result.payload.path.filter((i: any) =>
                              result.payload.zonk
                                ? !result.payload.zonk.includes(i)
                                : true
                            ),
                          ].reverse();
                          chunkArray(
                            fromBottom,
                            window.dataPos[orientation][
                              playerbet.manual.difficulty
                            ].col
                          ).map((chunkPath, idx) => {
                            // setTimeout(() => {
                            chunkPath.map((path) => {
                              arrIdxChest[path].setTexture(
                                "open-win-".concat(playerbet.manual.difficulty)
                              );
                              arrIdxChest[path].setAlpha(1);
                              console.log("setAlpha 1");

                              const prize = window.add.spine(
                                arrIdxChest[path].x,
                                arrIdxChest[path].y,
                                "egg",
                                "egg ".concat(
                                  difficultyToAnime[playerbet.manual.difficulty]
                                ),
                                false
                              );
                              prize.setScale(
                                window.dataPos[orientation][
                                  playerbet.manual.difficulty
                                ].scale || 1
                              );
                              prize.setAlpha(1);
                              console.log("setAlpha 1");

                              window.prizes.push(prize);
                            });

                            // }, idx * 300);
                          });

                          dispatch(countOpen(result.payload.path.length));

                          // setOpen(true);
                        }
                    }
                  },
                });

                if (
                  (idx + 1) %
                    window.dataPos[orientation][playerbet.manual.difficulty]
                      .col ==
                  0
                ) {
                  portalLevel = portalLevel - 1;
                }
              }
            );
            // }, 0);
          };

          const requestSucceededManualStartUp =
            requestAnimationFrame(handleManual);

          console.log("do requestSucceededManualStartUp");

          return () => {
            console.log("cancel requestSucceededManualStartUp");
            cancelAnimationFrame(requestSucceededManualStartUp);
          };
        }
      }
    }
  }, [
    orientation,
    playerbet.manual.difficulty,
    playerbet.manual.start,
    playerbet.currMode,
  ]);

  // succeeded auto
  useLayoutEffect(() => {
    if (
      !dataProps &&
      playerbet.currMode == "auto" &&
      window.add &&
      window.prizes
    ) {
      if (result.status == "succeeded" && result.payload.path) {
        const requestSucceededAuto = requestAnimationFrame(() => {
          if (result.payload.path.length == game.selected.length) {
            // auto cashout
            // setShadowOpen(false);
            // setContentState("diamond");
            const arrIdxChest =
              window.portals[orientation][playerbet.auto.difficulty];
            arrIdxChest.map((i: any) => {
              i.removeAllListeners();
              // i.blendMode = window.Phaser.BlendModes.NORMAL;
            });
            const fromBottom = [
              ...result.payload.path.filter(
                (i: any) => !result.payload.zonk.includes(i)
              ),
            ].reverse();
            chunkArray(
              fromBottom,
              window.dataPos[orientation][playerbet.auto.difficulty].col
            ).map((chunkPath, idx) => {
              // setTimeout(() => {
              chunkPath.map((path) => {
                arrIdxChest[path].setTexture(
                  "open-win-".concat(playerbet.auto.difficulty)
                );
                arrIdxChest[path].setAlpha(1);
                console.log("setAlpha 1");

                const prize = window.add.spine(
                  arrIdxChest[path].x,
                  arrIdxChest[path].y,
                  "egg",
                  "egg ".concat(difficultyToAnime[playerbet.auto.difficulty]),
                  false
                );
                prize.setScale(
                  window.dataPos[orientation][playerbet.auto.difficulty]
                    .scale || 1
                );
                prize.setAlpha(1);
                window.prizes.push(prize);
                sound.playGem();
              });

              if (idx == 0) {
                if (
                  result.payload.path.filter((i: any) =>
                    result.payload.zonk.includes(i)
                  ).length
                ) {
                  animating = true;
                  window.dragon.setAnimation(0, "lose", false);
                  setTimeout(() => {
                    window.dragon.setAnimation(0, "idle", true);

                    animating = false;
                  }, window.dragon.state.tracks[window.dragon.state.tracks.length - 1].animation.duration * 1000);
                } else {
                  animating = true;
                  window.dragon.setAnimation(0, "win", false);
                  if (window.totalProfit) {
                    window.totalProfit.destroy();
                    window.totalProfit = undefined;
                  }
                  if (window.textProfit) {
                      clearTimeout(window.timeoutProfit);
                    window.textProfit.destroy();
                    window.textProfit = undefined;
                  }
                  window.totalProfit = window.add.spine(
                    orientation == "landscape" ? 490 : 530,
                    orientation == "landscape" ? 700 : 900,
                    "total",
                    "animation",
                    false
                  );
                  window.totalProfit.setDepth(2);
                  if (orientation == "landscape") {
                    window.totalProfit.setScale(1);
                  } else {
                    window.totalProfit.setScale(1.6);
                  }
                  window.textProfit = window.add.text(
                    orientation == "landscape" ? 490 : 530,
                    orientation == "landscape" ? 700 : 900,
                    handleFormatCurrency(
                      result.payload.prize *
                        result.payload.last_bet.button_bet.amount
                    ).toString(),
                    {
                      fontSize: "48px",
                      fill: "#ffffff",
                    }
                  );
                  window.textProfit.setOrigin(0.5);
                  window.textProfit.setDepth(2);

                  window.timeoutProfit = setTimeout(() => {
                    window.textProfit.destroy();
                    window.totalProfit.destroy();
                    window.totalProfit = undefined;
                  }, window.totalProfit.state.tracks[window.totalProfit.state.tracks.length - 1].animation.duration * 1000);
                  setTimeout(() => {
                    window.dragon.setAnimation(0, "idle", true);

                    animating = false;
                  }, window.dragon.state.tracks[window.dragon.state.tracks.length - 1].animation.duration * 1000);
                }
              }
              // }, idx * 300);
            });

            // setOpen(true);
          }
          if (result.payload.zonk.length && result.payload.zonk.length) {
            // setShadowOpen(false);
            // setContentState("bomb");
            // setOpen(true);

            const arrIdxChest =
              window.portals[orientation][playerbet.auto.difficulty];

            (result.payload.zonk as number[])
              .filter(
                (bombPosition) => !result.payload.path.includes(bombPosition)
              )
              .map((bombPosition) => {
                const postToIdx = Number(bombPosition);
                // console.log(postToIdx, bombPosition, arrIdxChest, arrIdxChest[postToIdx]);
                arrIdxChest[postToIdx].setTexture(
                  "open-lose-".concat(playerbet.auto.difficulty)
                );
                arrIdxChest[postToIdx].setAlpha(0.3);
                const prize = window.add.spine(
                  arrIdxChest[postToIdx].x,
                  arrIdxChest[postToIdx].y - 40,
                  "skull",
                  "".concat(difficultyToAnime[playerbet.auto.difficulty]),
                  false
                );
                prize.setScale(
                  window.dataPos[orientation][playerbet.auto.difficulty]
                    .scale || 1
                );
                prize.setAlpha(0.3);
                window.prizes.push(prize);
              });

            Array.from(
              {
                length:
                  9 *
                  window.dataPos[orientation][playerbet.auto.difficulty].col,
              },
              (_, index) => index.toString()
            )
              .filter((path) => !result.payload.path.includes(path))
              .filter((path) => !result.payload.zonk.includes(path))
              .map((path, idx) => {
                const postToIdx = Number(path);
                // console.log(postToIdx, path, arrIdxChest, arrIdxChest[postToIdx]);
                arrIdxChest[postToIdx].setTexture(
                  "open-win-".concat(playerbet.auto.difficulty)
                );
                arrIdxChest[postToIdx].setAlpha(0.3);
                const prize = window.add.spine(
                  arrIdxChest[postToIdx].x,
                  arrIdxChest[postToIdx].y,
                  "egg",
                  "egg ".concat(difficultyToAnime[playerbet.auto.difficulty]),
                  false
                );
                prize.setScale(
                  window.dataPos[orientation][playerbet.auto.difficulty]
                    .scale || 1
                );
                prize.setAlpha(0.3);
                window.prizes.push(prize);
              });

            const fromBottom = [
              ...result.payload.zonk.filter((i: any) =>
                result.payload.path.includes(i)
              ),
            ].reverse();
            chunkArray(
              fromBottom,
              window.dataPos[orientation][playerbet.auto.difficulty].col
            ).map((chunkPath, idx) => {
              // setTimeout(() => {
              chunkPath.map((path) => {
                arrIdxChest[path].setTexture(
                  "open-lose-".concat(playerbet.auto.difficulty)
                );
                arrIdxChest[path].setAlpha(1);
                console.log("setAlpha 1");

                const prize = window.add.spine(
                  arrIdxChest[path].x,
                  arrIdxChest[path].y - 40,
                  "skull",
                  "".concat(difficultyToAnime[playerbet.auto.difficulty]),
                  false
                );
                prize.setScale(
                  window.dataPos[orientation][playerbet.auto.difficulty]
                    .scale || 1
                );
                sound.playBomb();
                prize.setAlpha(1);
                window.prizes.push(prize);
              });
              // }, idx * 300);
            });
          }
        });
        console.log("do requestSucceededAuto");

        return () => {
          console.log("cancel requestSucceededAuto");
          cancelAnimationFrame(requestSucceededAuto);
        };
      }
    }
  }, [
    result.status,
    window.add,
    window.prizes,
    orientation,
    window.portals[orientation] &&
      window.portals[orientation][playerbet.auto.difficulty],
    playerbet.auto.difficulty,
    playerbet.auto.start,
    playerbet.currMode,
    game.selected,
  ]);

  // succeeded manual non startup
  useLayoutEffect(() => {
    if (!dataProps && playerbet.currMode == "manual") {
      if (result.status == "succeeded" && result.payload.path) {
        const requestSucceededManualNonStartUp = requestAnimationFrame(() => {
          if (
            result.payload.path.length == window.currPortalLevel &&
            !result.payload.zonk &&
            result.payload.last_bet.button_bet.state == "sweep" &&
            window.portals[orientation][playerbet.manual.difficulty][
              Number(result.payload.last_bet.button_bet.path)
            ].openPortal
          ) {
            window.portals[orientation][playerbet.manual.difficulty][
              Number(result.payload.last_bet.button_bet.path)
            ].openPortal("open-win-");
          }
          if (
            result.payload.zonk &&
            result.payload.last_bet.button_bet.state == "sweep" &&
            window.portals[orientation][playerbet.manual.difficulty][
              Number(result.payload.last_bet.button_bet.path)
            ].openPortal
          ) {
            const arrIdxChest =
              window.portals[orientation][playerbet.manual.difficulty];
            (result.payload.zonk as number[])
              .filter(
                (bombPosition) => !result.payload.path.includes(bombPosition)
              )
              .map((bombPosition) => {
                // requestAnimationFrame(() => {
                setTimeout(() => {
                  const postToIdx = Number(bombPosition);
                  // console.log(postToIdx, bombPosition, arrIdxChest, arrIdxChest[postToIdx]);
                  // arrIdxChest[postToIdx].setAlpha(0.1);
                  // arrIdxChest[postToIdx].setAlpha(0.3);
                  arrIdxChest[postToIdx]
                    .setTexture(
                      "open-lose-".concat(playerbet.manual.difficulty)
                    )
                    .setAlpha(0.3);
                  // arrIdxChest[postToIdx].alpha = (0.3);
                  console.log("setAlpha 0.3");
                  window.prizes.push(
                    window.add.spine(
                      arrIdxChest[postToIdx].x,
                      arrIdxChest[postToIdx].y - 40,
                      "skull",
                      "".concat(difficultyToAnime[playerbet.manual.difficulty]),
                      false
                    )
                  );
                  window.prizes[window.prizes.length - 1].setScale(
                    window.dataPos[orientation][playerbet.manual.difficulty]
                      .scale || 1
                  );
                  window.prizes[window.prizes.length - 1].setAlpha(0.3);
                  console.log("setAlpha 0.3", arrIdxChest[postToIdx]._alpha);
                }, 100);
                // });
              });

            Array.from(
              {
                length:
                  9 *
                  window.dataPos[orientation][playerbet.manual.difficulty].col,
              },
              (_, index) => index.toString()
            )
              .filter((path) => !result.payload.path.includes(path))
              .filter((path) => !result.payload.zonk.includes(path))
              .map((path, idx) => {
                // requestAnimationFrame(() => {
                setTimeout(() => {
                  const postToIdx = Number(path);
                  // console.log(postToIdx, path, arrIdxChest, arrIdxChest[postToIdx]);
                  // arrIdxChest[postToIdx].setAlpha(0.1);
                  // arrIdxChest[postToIdx].setAlpha(0.3);
                  arrIdxChest[postToIdx]
                    .setTexture("open-win-".concat(playerbet.manual.difficulty))
                    .setAlpha(0.3);
                  // arrIdxChest[postToIdx].alpha = (0.3);
                  // console.log('setAlpha 0.3', arrIdxChest[postToIdx]._alpha);
                  window.prizes.push(
                    window.add.spine(
                      arrIdxChest[postToIdx].x,
                      arrIdxChest[postToIdx].y,
                      "egg",
                      "egg ".concat(
                        difficultyToAnime[playerbet.manual.difficulty]
                      ),
                      false
                    )
                  );
                  window.prizes[window.prizes.length - 1].setScale(
                    window.dataPos[orientation][playerbet.manual.difficulty]
                      .scale || 1
                  );
                  window.prizes[window.prizes.length - 1].setAlpha(0.3);
                  console.log("setAlpha 0.3", arrIdxChest[postToIdx]._alpha);
                  // });
                }, 100);
              });

            window.portals[orientation][playerbet.manual.difficulty][
              Number(result.payload.last_bet.button_bet.path)
            ].openPortal("open-lose-");
          }

          if (result.payload.last_bet.button_bet.state == "cashout") {
            const arrIdxChest =
              window.portals[orientation][playerbet.manual.difficulty];
            (result.payload.zonk as number[])
              .filter(
                (bombPosition) => !result.payload.path.includes(bombPosition)
              )
              .map((bombPosition) => {
                const postToIdx = Number(bombPosition);
                // console.log(postToIdx, bombPosition, arrIdxChest, arrIdxChest[postToIdx]);
                arrIdxChest[postToIdx].setTexture(
                  "open-lose-".concat(playerbet.manual.difficulty)
                );
                arrIdxChest[postToIdx].setAlpha(0.3);
                const prize = window.add.spine(
                  arrIdxChest[postToIdx].x,
                  arrIdxChest[postToIdx].y - 40,
                  "skull",
                  "".concat(difficultyToAnime[playerbet.manual.difficulty]),
                  false
                );

                prize.setScale(
                  window.dataPos[orientation][playerbet.manual.difficulty]
                    .scale || 1
                );
                prize.setAlpha(0.3);
                window.prizes.push(prize);
              });
            Array.from(
              {
                length:
                  9 *
                  window.dataPos[orientation][playerbet.manual.difficulty].col,
              },
              (_, index) => index.toString()
            )
              .filter((path) => !result.payload.path.includes(path))
              .filter((path) => !result.payload.zonk.includes(path))
              .map((path, idx) => {
                const postToIdx = Number(path);
                // console.log(postToIdx, path, arrIdxChest, arrIdxChest[postToIdx]);
                arrIdxChest[postToIdx].setTexture(
                  "open-win-".concat(playerbet.manual.difficulty)
                );
                arrIdxChest[postToIdx].setAlpha(0.3);
                const prize = window.add.spine(
                  arrIdxChest[postToIdx].x,
                  arrIdxChest[postToIdx].y,
                  "egg",
                  "egg ".concat(difficultyToAnime[playerbet.manual.difficulty]),
                  false
                );

                prize.setScale(
                  window.dataPos[orientation][playerbet.manual.difficulty]
                    .scale || 1
                );
                prize.setAlpha(0.3);
                window.prizes.push(prize);
              });
            const fromBottom = [
              ...result.payload.path.filter(
                (i: any) => !result.payload.zonk.includes(i)
              ),
            ].reverse();
            chunkArray(
              fromBottom,
              window.dataPos[orientation][playerbet.manual.difficulty].col
            ).map((chunkPath, idx) => {
              // setTimeout(() => {
              chunkPath.map((path) => {
                arrIdxChest[path].setTexture(
                  "open-win-".concat(playerbet.manual.difficulty)
                );
                arrIdxChest[path].setAlpha(1);
                console.log("setAlpha 1");
                const prize = window.add.spine(
                  arrIdxChest[path].x,
                  arrIdxChest[path].y,
                  "egg",
                  "egg ".concat(difficultyToAnime[playerbet.manual.difficulty]),
                  false
                );
                prize.setScale(
                  window.dataPos[orientation][playerbet.manual.difficulty]
                    .scale || 1
                );
                prize.setAlpha(1);
                window.prizes.push(prize);
              });
            });
            dispatch(stopBet());
            if (window.totalProfit) {
              window.totalProfit.destroy();
              window.totalProfit = undefined;
            }
            if (window.textProfit) {
                clearTimeout(window.timeoutProfit);
              window.textProfit.destroy();
              window.textProfit = undefined;
            }
            window.totalProfit = window.add.spine(
              orientation == "landscape" ? 490 : 530,
              orientation == "landscape" ? 700 : 900,
              "total",
              "animation",
              false
            );
            window.totalProfit.setDepth(2);
            if (orientation == "landscape") {
              window.totalProfit.setScale(1);
            } else {
              window.totalProfit.setScale(1.6);
            }
            window.textProfit = window.add.text(
              orientation == "landscape" ? 490 : 530,
              orientation == "landscape" ? 700 : 900,
              handleFormatCurrency(
                result.payload.prize * result.payload.last_bet.button_bet.amount
              ).toString(),
              {
                fontSize: "48px",
                fill: "#ffffff",
              }
            );
            window.textProfit.setOrigin(0.5);
            window.textProfit.setDepth(2);

            window.timeoutProfit = setTimeout(() => {
              window.textProfit.destroy();
              window.totalProfit.destroy();
              window.totalProfit = undefined;
            }, window.totalProfit.state.tracks[window.totalProfit.state.tracks.length - 1].animation.duration * 1000);
          }
        });
        console.log("do requestSucceededManualNonStartUp");

        return () => {
          console.log("cancel requestSucceededManualNonStartUp");
          cancelAnimationFrame(requestSucceededManualNonStartUp);
        };
      }
    }
    // @ts-ignore
  }, [
    result.status,
    // @ts-ignore

    last_bet &&
      // @ts-ignore

      last_bet.length != 0 &&
      // @ts-ignore

      !last_bet.state &&
      // @ts-ignore

      last_bet.path &&
      // @ts-ignore

      last_bet.path.length,
    orientation,
    window.portals[orientation] &&
    window.portals[orientation][playerbet.manual.difficulty]
      ? window.portals[orientation][playerbet.manual.difficulty]
      : false,
    playerbet.manual.difficulty,
    playerbet.manual.start,
    playerbet.currMode,
  ]);

  // cleaning manual
  useLayoutEffect(() => {
    const requestCleaningManual = requestAnimationFrame(() => {
      if (!dataProps && playerbet.currMode == "manual") {
        if (result.status == "finished") {
          console.log("clean by manual", result.status);
          orientationData.map((mode) => {
            difficultyData.map((level) => {
              if (window.prizes) {
                window.prizes.map((prize: any) => {
                  prize.destroy();
                });
                window.prizes = [];
              }
              window.portals[mode] &&
                window.portals[mode][level].map((portal: any) => {
                  portal.setTexture(window.dataPos[mode][level].imgName);
                  // portal.blendMode = window.Phaser.BlendModes.NORMAL;
                  portal.removeAllListeners();
                  if (portal.alpha != 0) {
                    window.game.scene.getAt(0).tweens.add({
                      targets: portal,
                      scaleX: 0,
                      scaleY: 0,
                      alpha: 0,
                      delay: 0,
                      duration: 0,
                      onComplete: () => {},
                    });
                  }
                });
            });
          });
          // }, 0);

          if (window.totalProfit) {
            window.totalProfit.destroy();
            window.totalProfit = undefined;
          }
          if (window.textProfit) {
              clearTimeout(window.timeoutProfit);
            window.textProfit.destroy();
            window.textProfit = undefined;
          }
        }
      }
    });
    console.log("do requestCleaningManual");

    return () => {
      console.log("cancel requestCleaningManual");
      cancelAnimationFrame(requestCleaningManual);
    };
  }, [
    playerbet.currMode,
    orientation,
    result.status,
    window.prizes,
    window.portals,
  ]);

  // clean auto
  useLayoutEffect(() => {
    if (!dataProps && playerbet.currMode == "auto") {
      if (result.status == "finished") {
        const requestCleaningAuto = requestAnimationFrame(() => {
          console.log("clean by auto ", result.status);
          orientationData.map((mode) => {
            difficultyData.map((level) => {
              if (window.prizes) {
                window.prizes.map((prize: any) => {
                  prize.destroy();
                });
                window.prizes = [];
              }
              window.portals[mode] &&
                window.portals[mode][level].map((portal: any) => {
                  portal.setTexture(window.dataPos[mode][level].imgName);
                  // portal.blendMode = window.Phaser.BlendModes.NORMAL;
                  portal.removeAllListeners();
                  if (portal.alpha != 0) {
                    window.game.scene.getAt(0).tweens.add({
                      targets: portal,
                      scaleX: 0,
                      scaleY: 0,
                      alpha: 0,
                      delay: 0,
                      duration: 0,
                      onComplete: () => {},
                    });
                  }
                });
            });
          });
          // }, 0);
        });
        console.log("do requestCleaningAuto");

        return () => {
          console.log("cancel requestCleaningAuto");
          cancelAnimationFrame(requestCleaningAuto);
        };
      }

      if (window.totalProfit) {
        window.totalProfit.destroy();
        window.totalProfit = undefined;
      }
      if (window.textProfit) {
          clearTimeout(window.timeoutProfit);
        window.textProfit.destroy();
        window.textProfit = undefined;
      }
    }
  }, [
    playerbet.currMode,
    orientation,
    result.status,
    window.prizes,
    window.portals,
  ]);

  // idle manual
  useEffect(() => {
    if (playerbet.currMode == "manual") {
      if (result.status == "idle") {
        if (
          window.portals[orientation] &&
          window.portals[orientation][playerbet.manual.difficulty]
        ) {
          const handleManual = () => {
            // if(window.portals[orientation][playerbet.manual.difficulty].some((i: any)=>i._alpha !==0)) return;

            const handleClick = (
              e: any,
              portalLevel: number,
              idxChest: number
            ) => {
              const handleOnClick = () => {
                // console.log(e, animating, !window.currPortalLevel, portalLevel, window.currPortalLevel, !playerbet.manual.start);
                if (
                  !window.currPortalLevel ||
                  portalLevel != window.currPortalLevel ||
                  !playerbet.manual.start
                )
                  return;
                // if(window.prizes.length+1!==window.currPortalLevel) return;
                // const array: any = ['open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-lose-', 'open-lose-', 'open-lose-', 'open-lose-'];

                // const newPortalTexture = array[Math.floor(Math.random() * array.length)].concat(playerbet.manual.difficulty);
                window.portals[orientation][playerbet.manual.difficulty][
                  idxChest
                ].openPortal = (newPortalTexture: string, idxChest: number) => {
                  if (
                    !window.currPortalLevel ||
                    portalLevel != window.currPortalLevel ||
                    !playerbet.manual.start
                  )
                    return;

                  e.setTexture(
                    newPortalTexture.concat(playerbet.manual.difficulty)
                  );
                  if (newPortalTexture.includes("lose")) {
                    animating = true;
                    window.dragon.setAnimation(0, "lose", false);
                    window.currPortalLevel = 1;
                    const currPortal = [
                      ...window.portals[orientation][
                        playerbet.manual.difficulty
                      ],
                    ].reverse();
                    chunkArray(
                      currPortal,
                      window.dataPos[orientation][playerbet.manual.difficulty]
                        .col
                    ).map((chunk, idx) => {
                      chunk.map((i: any) => {
                        i.removeAllListeners();
                      });
                    });
                    setTimeout(() => {
                      window.dragon.setAnimation(0, "idle", true);
                      const currPortal = [
                        ...window.portals[orientation][
                          playerbet.manual.difficulty
                        ],
                      ].reverse();
                      chunkArray(
                        currPortal,
                        window.dataPos[orientation][playerbet.manual.difficulty]
                          .col
                      ).map((chunk, idx) => {
                        chunk.map((i: any) => i.setAlpha(0.3));
                        if (idx + 1 <= window.currPortalLevel) {
                          chunk.map((i: any) => {
                            i.setAlpha(1);
                            console.log("setAlpha 1", window.currPortalLevel);
                          });
                        }
                      });
                      dispatch(stopBet());

                      animating = false;
                    }, window.dragon.state.tracks[window.dragon.state.tracks.length - 1].animation.duration * 1000);
                    dispatch(openBomb());
                    // dispatch(resultFinished());
                    // dispatch(resetResult());

                    sound.playBomb();
                    window.prizes.push(
                      window.add.spine(
                        e.x,
                        e.y - 40,
                        "skull",
                        "".concat(
                          difficultyToAnime[playerbet.manual.difficulty]
                        ),
                        false
                      )
                    );
                    window.prizes[window.prizes.length - 1].setScale(
                      window.dataPos[orientation][playerbet.manual.difficulty]
                        .scale || 1
                    );
                  }
                  if (newPortalTexture.includes("win")) {
                    animating = true;
                    window.dragon.setAnimation(0, "win", false);
                    window.currPortalLevel = window.currPortalLevel + 1;
                    const currPortal = [
                      ...window.portals[orientation][
                        playerbet.manual.difficulty
                      ],
                    ].reverse();
                    chunkArray(
                      currPortal,
                      window.dataPos[orientation][playerbet.manual.difficulty]
                        .col
                    ).map((chunk, idx) => {
                      chunk.map((i: any) => i.setAlpha(0.3));

                      if (idx + 1 <= window.currPortalLevel) {
                        chunk.map((i: any) => {
                          i.setAlpha(1);
                          console.log("setAlpha 1", window.currPortalLevel);
                        });
                      }
                    });
                    setTimeout(() => {
                      window.dragon.setAnimation(0, "idle", true);
                      const currPortal = [
                        ...window.portals[orientation][
                          playerbet.manual.difficulty
                        ],
                      ].reverse();
                      chunkArray(
                        currPortal,
                        window.dataPos[orientation][playerbet.manual.difficulty]
                          .col
                      ).map((chunk, idx) => {
                        if (idx + 1 < window.currPortalLevel) {
                          chunk.map((i: any) => {
                            i.removeAllListeners();
                            // i.blendMode = window.Phaser.BlendModes.NORMAL;
                          });
                        }
                      });
                      if (window.currPortalLevel - 1 == 9)
                        window.handleCashOut();
                      animating = false;
                    }, window.dragon.state.tracks[window.dragon.state.tracks.length - 1].animation.duration * 1000);
                    dispatch(countOpen(game.openCount + 1));
                    sound.playGem();
                    window.prizes.push(
                      window.add.spine(
                        e.x,
                        e.y,
                        "egg",
                        "egg ".concat(
                          difficultyToAnime[playerbet.manual.difficulty]
                        ),
                        false
                      )
                    );
                    window.prizes[window.prizes.length - 1].setScale(
                      window.dataPos[orientation][playerbet.manual.difficulty]
                        .scale || 1
                    );
                  }
                };

                const sendBet: SendBet = {
                  game: "DP000001",
                  total_amount: playerbet.manual.amount,
                  button_bet: {
                    amount: playerbet.manual.amount,
                    difficulty: playerbet.manual.difficulty,
                    path: idxChest + "",
                    round_id: history.current_round,
                    state: "sweep",
                  },
                  round_id: history.current_round,
                };
                // console.log("sweep", idxChest)
                window.sweepPortal(sendBet, idxChest);
              };

              return handleOnClick;
            };

            const row = 9;
            let portalLevel = row;
            window.currPortalLevel = 1;
            window.portals[orientation][playerbet.manual.difficulty].map(
              (portal: any, idx: number) => {
                window.portals[orientation][playerbet.manual.difficulty][
                  idx
                ].handleClick = handleClick(portal, portalLevel, idx);
                portal.removeAllListeners();
                window.game.scene.getAt(0).tweens.add({
                  targets: portal,
                  scaleX:
                    window.dataPos[orientation][playerbet.manual.difficulty]
                      .scale || 1,
                  scaleY:
                    window.dataPos[orientation][playerbet.manual.difficulty]
                      .scale || 1,
                  alpha: 1,
                  delay: 0,
                  duration: 300,
                  onComplete: () => {
                    // console.log('pointerdown', idx);
                    portal.removeAllListeners();
                    portal.setInteractive();
                    portal.on(
                      "pointerdown",
                      window.portals[orientation][playerbet.manual.difficulty][
                        idx
                      ].handleClick
                    );
                    if (
                      playerbet.manual.start &&
                      idx ==
                        window.portals[orientation][playerbet.manual.difficulty]
                          .length -
                          1
                    ) {
                      const currPortal = [
                        ...window.portals[orientation][
                          playerbet.manual.difficulty
                        ],
                      ].reverse();
                      chunkArray(
                        currPortal,
                        window.dataPos[orientation][playerbet.manual.difficulty]
                          .col
                      ).map((chunk, idx) => {
                        chunk.map((i: any) => i.setAlpha(0.3));
                        if (idx + 1 <= window.currPortalLevel) {
                          chunk.map((i: any) => {
                            i.setAlpha(1);
                            console.log("setAlpha 1");
                          });
                        }
                      });
                    }
                  },
                });

                if (
                  (idx + 1) %
                    window.dataPos[orientation][playerbet.manual.difficulty]
                      .col ==
                  0
                ) {
                  portalLevel = portalLevel - 1;
                }
              }
            );
            // }, 0);
          };

          const requestIdleManual = requestAnimationFrame(handleManual);

          console.log("do requestIdleManual");

          return () => {
            console.log("cancel requestIdleManual");
            cancelAnimationFrame(requestIdleManual);
          };
        }
      }
    }
  }, [
    orientation,
    playerbet.manual.difficulty,
    playerbet.manual.start,
    playerbet.currMode,
    result.status,
  ]);

  // idle auto
  useEffect(() => {
    if (playerbet.currMode == "auto") {
      if (result.status == "idle") {
        if (
          window.portals[orientation] &&
          window.portals[orientation][playerbet.auto.difficulty]
        ) {
          const requestIdleAuto = requestAnimationFrame(() => {
            console.log("request auto idle");

            const handleClick = (e: any, portalLevel: number, idx: number) => {
              const handleOnClick = () => {
                console.log(e, portalLevel, window.currPortalLevel, idx);
                if (playerbet.auto.start) return;
                if (window.currPortalLevel < portalLevel) return;
                if (e._alpha == 0.3 || e.alpha == 0.3) {
                  e.setAlpha(1);
                  console.log("setAlpha 1");
                  const currPortal = [
                    ...window.portals[orientation][playerbet.auto.difficulty],
                  ].reverse();
                  chunkArray(
                    currPortal,
                    window.dataPos[orientation][playerbet.auto.difficulty].col
                  ).map((chunk, idx) => {
                    if (idx + 1 > portalLevel) {
                      chunk.map((i: any) => {
                        i.setAlpha(1);
                        // console.log("setAlpha 1");
                      });
                    }
                  });
                  window.currPortalLevel = portalLevel;
                  const currPortal2 = [
                    ...window.portals[orientation][playerbet.auto.difficulty],
                  ].reverse();

                  dispatch(
                    selectToOpen(
                      currPortal2
                        .filter((i) => i._alpha == 0.3)
                        .map((_, idx) => idx)
                    )
                  );
                  return;
                }
                const currPortal = [
                  ...window.portals[orientation][playerbet.auto.difficulty],
                ].reverse();
                chunkArray(
                  currPortal,
                  window.dataPos[orientation][playerbet.auto.difficulty].col
                ).map((chunk, idx) => {
                  if (idx + 1 == portalLevel) {
                    chunk.map((i: any) => {
                      i.setAlpha(1);
                      // console.log("setAlpha 1");
                    });
                  }
                });
                e.setAlpha(0.3);
                const currPortal2 =
                  window.portals[orientation][playerbet.auto.difficulty];
                const selected: any = [];
                currPortal2.map((i: any, idx: number) => {
                  if (i._alpha == 0.3) {
                    selected.push(idx + "");
                  }
                });
                window.currPortalLevel = selected.length + 1;
                dispatch(selectToOpen(selected));
              };

              return handleOnClick;
            };

            const row = 9;
            let portalLevel = row;
            window.currPortalLevel =
              window.gameSelected && window.gameSelected.length
                ? window.gameSelected.length + 1
                : 1;
            window.portals[orientation][playerbet.auto.difficulty].map(
              (portal: any, idx: number) => {
                window.portals[orientation][playerbet.auto.difficulty][
                  idx
                ].handleClick = handleClick(portal, portalLevel, idx);
                portal.removeAllListeners();

                window.game.scene.getAt(0).tweens.add({
                  targets: portal,
                  scaleX:
                    window.dataPos[orientation][playerbet.auto.difficulty]
                      .scale || 1,
                  scaleY:
                    window.dataPos[orientation][playerbet.auto.difficulty]
                      .scale || 1,
                  alpha:
                    window.gameSelected &&
                    window.gameSelected.includes(idx + "")
                      ? 0.3
                      : 1,
                  delay: 0,
                  duration: 300,
                  onComplete: () => {
                    portal.removeAllListeners();
                    portal.on(
                      "pointerdown",
                      window.portals[orientation][playerbet.auto.difficulty][
                        idx
                      ].handleClick
                    );
                  },
                });

                if (
                  (idx + 1) %
                    window.dataPos[orientation][playerbet.auto.difficulty]
                      .col ==
                  0
                ) {
                  portalLevel = portalLevel - 1;
                }
              }
            );
          });
          console.log("do requestIdleAuto");

          return () => {
            console.log("cancel requestIdleAuto");
            cancelAnimationFrame(requestIdleAuto);
          };
        }
      }
    }
  }, [
    orientation,
    window.portals[orientation] &&
      window.portals[orientation][playerbet.auto.difficulty],
    playerbet.auto.difficulty,
    playerbet.auto.start,
    playerbet.currMode,
    result.status,
  ]);

  const portalsDifficult: any = {
    easy: 4,
    medium: 3,
    hard: 2,
    expert: 3,
    master: 4,
  };
  // console.log(dataProps)
  return (
    <div
      className={"game-container ".concat(
        `${
          dataProps
            ? "game-history-table"
            : "main "
                .concat(playerbet[playerbet.currMode].difficulty)
                .concat(" ")
                .concat(playerbet.currMode)
        }`
      )}
    >
      <div className="game-wrapper">
        {/* <PhaserComponent /> */}

        {dataProps ? (
          <div className={"portal-container"}>
            {Array.from(Array(9).keys()).map((idxRow) => {
              return (
                <div
                  key={`${dataProps ? "history" : "main"}-row-${idxRow}-${""}`}
                  className="row"
                >
                  {Array.from(
                    Array(
                      portalsDifficult[dataProps.data.detail_bet.difficulty]
                    ).keys()
                  ).map((idxCol) => {
                    const idxChest =
                      idxRow *
                        portalsDifficult[dataProps.data.detail_bet.difficulty] +
                      idxCol;

                    return (
                      <Chest
                        key={`${
                          dataProps ? "history" : "main"
                        }-col-box-${idxChest}`}
                        {...{
                          idxChest,
                          dataProps,
                          handleClick: () => {},
                          selected: game.selected.includes(idxChest),
                          idxRow,
                        }}
                      />
                    );
                  })}
                </div>
              );
            })}
          </div>
        ) : (
          <></>
        )}
      </div>
      {}
    </div>
  );
};

export default Game;

export const images = {
  // Diamond1, Diamond2, Diamond3, Diamond4, Diamond5
};

export const randomProperty: (T: typeof images) => keyof typeof images = (
  obj
) => {
  const keys = Object.keys(obj);
  return keys[(keys.length * Math.random()) << 0] as keyof typeof images;
};
export const cachedDataImage = (url: any) => {
  return new Promise<string>(async (callback) => {
    // if (document.querySelector('.safari.iPhone'))
    return callback(url);

    caches.open(ASSETS_IMAGE_CACHED).then((cache) => {
      cache.match(url).then(async (data) => {
        if (!data) return callback(url);
        let reader = new FileReader();
        reader.onload = function () {
          callback(this.result as string);
        };
        reader.readAsDataURL(await data!.blob());
      });
    });
  });
};

export function chunkArray(array: any[], size: number) {
  const chunkedArray = [];
  let index = 0;

  while (index < array.length) {
    chunkedArray.push(array.slice(index, index + size));
    index += size;
  }

  return chunkedArray;
}
